// removed by extract-text-webpack-plugin
module.exports = {"options-container":"MenuOptionsContainer__options-container___G0ZWe","policy-container":"MenuOptionsContainer__policy-container___3scZe"};